import { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Select, MenuItem, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { graphqlQuery } from "../../../../data/Axios/DynamicService";
import Swal from "sweetalert2"; // Import Swal for success/error messages
import { mpesaPay } from "../../../../data/DynamicTable/DynamicFunctions";

const base_url = "https://localhost:7237/graphql/";

const allSubs = `{
  subscriptionPaymentEntries {
    error
    results
  }
}`;

function SubscriptionPaymentEntry() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [paymentOption, setPaymentOption] = useState("subscription");
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0); // State for displaying dynamic amount
  const [phoneNumber, setPhoneNumber] = useState(""); // State for phone number input


  useEffect(() => {
    async function fetchAllData() {
      setLoading(true);
      try {
        const data = await graphqlQuery(allSubs, base_url);
        if (data?.results) {
          const parsedResults = JSON.parse(data?.results);
          setRows(parsedResults);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, []);

  const handlePayClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    setPaymentOption("subscription");
  };

  const handlePayment = async () => {
    const paymentValues = {
      phoneNumber: phoneNumber, // Replace with the actual phone number logic
      amount: parseInt(amount), // Use dynamic amount based on the payment option
      //subscriptionPlan: "plan1",
    };

    try {
      await processPayment(paymentValues); // Call the payment function
    } catch (error) {
      console.error("Payment error:", error);
    }

    handleClose();
  };

  // Async function for processing payment
  const processPayment = async (values) => {
    const { phoneNumber, amount, subscriptionPlan } = values;

    try {
      const response = await mpesaPay(amount, phoneNumber, subscriptionPlan);
      if (response.status === 200) {
        Swal.fire("Success!", "Payment initiated successfully!", "success");
      } else {
        Swal.fire("Error!", "Payment failed! Please try again.", "error");
      }
    } catch (error) {
      Swal.fire("Error!", "Please contact the Admin.", "error");
    }
  };

  const handlePaymentOptionChange = (e) => {
    setPaymentOption(e.target.value);
    const selectedAmount =
      e.target.value === "subscription"
        ? selectedRow.SubscriptionAmount
        : selectedRow.SubscriptionAmount + selectedRow.ChargesAmount;

        setAmount(parseFloat(selectedAmount).toFixed(2)); // Format to 2 decimal places
      };

  const columns = [
    { field: "Id", headerName: "ID", width: 80 },
    { field: "ReferenceNo", headerName: "Reference No", width: 200 },
    { field: "PaymentType", headerName: "Payment Type", width: 150 },
    { field: "Account", headerName: "Account", width: 180 },
    { field: "SubscriptionAmount", headerName: "Subscription Amount", width: 180 },
    { field: "ChargesAmount", headerName: "Other Charges", width: 150 },
    { field: "TotalAmount", headerName: "Total Amount", width: 180 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <Button variant="contained" color="primary" onClick={() => handlePayClick(params.row)}>
          Pay
        </Button>
      ),
    },
  ];

  return (
    <Box m={2}>
      <Typography variant="h5" gutterBottom>
        Subscription Payment Entry
      </Typography>
      <Typography variant="body1" gutterBottom>
        Create, view, or edit Subscription Payment Entry
      </Typography>
      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid rows={rows} columns={columns} pageSize={5} getRowId={(row) => row.Id} loading={loading} />
      </Box>

      {/* Payment Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Process Payment</DialogTitle>
        <DialogContent>
          {selectedRow && (
            <>
              <Typography variant="h6">Reference No: {selectedRow.ReferenceNo}</Typography>
              <Typography>Subscription Amount: KSH {selectedRow.SubscriptionAmount}</Typography>
              <Typography>Other Charges: KSH {selectedRow.ChargesAmount}</Typography>
              <Typography>Total Amount: KSH {(selectedRow.SubscriptionAmount + selectedRow.ChargesAmount).toFixed(2)}</Typography>

              <Select
                fullWidth
                value={paymentOption}
                onChange={handlePaymentOptionChange}
                sx={{ mt: 2 }}
              >
                <MenuItem value="subscription">Pay Subscription Only</MenuItem>
                <MenuItem value="full">Pay Full Amount</MenuItem>
              </Select>

              {/* Displaying the calculated amount */}
              <TextField
                fullWidth
                label="Amount"
                value={amount}
                disabled
                sx={{ mt: 2 }}
              />
              {/* Phone Number input */}
              <TextField
                fullWidth
                label="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                sx={{ mt: 2 }}
                type="tel"
                required
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handlePayment} color="primary" variant="contained">
            Pay
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default SubscriptionPaymentEntry;
